import store from "@/store"
import Repository from "@/repositories/api.js"
const resource = "/admin/qr_codes"

export default {
  async getAll() {
    let response = await Repository.get(resource, {
      params: { region_id: store.state.auth.chosenRegion }
    })
    return response.data.qr_codes
  },
  async get(qrCodeId) {
    let response = await Repository.get(`${resource}/${qrCodeId}`)
    return response.data.qr_code
  },
  async create(qrCodeData) {
    let response = await Repository.post(`${resource}`, {
      region_id: store.state.auth.chosenRegion,
      qr_code: qrCodeData
    })
    return response.data
  },
  async update(qrCodeId, qrCodeData) {
    let response = await Repository.patch(`${resource}/${qrCodeId}`, {
      qr_code: qrCodeData
    })
    return response.data
  },
  async destroy(qrCodeId) {
    let response = await Repository.delete(`${resource}/${qrCodeId}`)
    return response.data
  }
}
